import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { jobApplicationsOptions } from '../../../../contactsFilters/defaultFilters';

export const useNumberOfApplicantsFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    numberOfApplicants: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.mixed(),
    }),
  });

  const onSubmit = ({ numberOfApplicants }) => {
    setFilters(
      { numberOfApplicants: numberOfApplicants.value || 'any' },
      {
        removeFilters: numberOfApplicants.value === 'any' ? ['numberOfApplicants'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
    numberOfApplicantsOptions: jobApplicationsOptions,
  };
};

useNumberOfApplicantsFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
